// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;May the mountains bring forth peace,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and the little hills righteousness for the people.<br> </p> </div></div>";
// Exports
module.exports = code;